import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed.
 *  An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function maxCurrentYearValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
) {
  const model = control.value;
  let msg: string = '';
  if (!model) {
    return null;
  }

  const currentYear = new Date().getFullYear();
  if (model > currentYear) {
    msg = "The year should be less than or equal to "+currentYear.toString();
  }

  return !msg
  ? null
  : {
    minCurrentYearValidator: {
      message: msg,
    }
  };
}

